import React from "react";
import { useNavigate } from "react-router-dom";

const ResumeAndHireMeButton = () => {
  const navigate = useNavigate();
  return (
    <div className="mt-8 flex flex-col sm:flex-row justify-center gap-4">
      <button
        className="px-6 py-3 bg-white text-teal-700 font-semibold rounded-xl border border-teal-600 shadow-md hover:bg-teal-50 hover:scale-105 transition-transform duration-300 text-center"
        onClick={() => navigate("/Contact")}
      >
        💼 Hire Me
      </button>

      {/* Resume - dark button, white icon and text */}
      <a
        href="https://drive.google.com/file/d/1gWn17QZR_YNszEuYkGMnAA7FI6Sbznr9/view?usp=sharing"
        target="_blank"
        rel="noopener noreferrer"
        className="px-6 py-3 bg-teal-600 text-white font-semibold rounded-xl shadow-md hover:bg-teal-700 hover:scale-105 transition-transform duration-300 text-center"
      >
        📄 Resume
      </a>
    </div>
  );
};

export default ResumeAndHireMeButton;
